/*
 * availability/lib.js — pure helpers + constants for the Availability page.
 * Extracted from pages/Availability.jsx during the iter175 hardening pass so
 * the parent stays focused on state orchestration.
 */

// Only 2 kinds now — reasons live in a separate multi-select checkbox group.
export const KIND_OPTIONS = [
  { value: "available", label: "Available", tone: "green" },
  { value: "unavailable", label: "Unavailable", tone: "red" },
];

export const OP_ROLES = [
  "admin", "super_admin", "supervisor", "dispatcher",
  "operations_manager", "chief_security_officer",
];

// Local YYYY-MM-DD helper — avoids UTC shift bugs when the browser is west of UTC.
export function isoDate(d) {
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, "0");
  const day = String(d.getDate()).padStart(2, "0");
  return `${y}-${m}-${day}`;
}

export function forwardRange(days) {
  const start = new Date();
  const end = new Date(start);
  end.setDate(end.getDate() + days);
  return { start: isoDate(start), end: isoDate(end) };
}

export const emptyForm = () => {
  const today = isoDate(new Date());
  return {
    guard_id: "",
    start_date: today,
    end_date: today,
    start_time: "",
    end_time: "",
    kind: "available",
    reasons: [],
    notes: "",
  };
};

// Deterministic group key used by the grouping memo — matching keys on adjacent
// dates collapse to a single "range" row for display purposes.
export function groupKey(r) {
  return [
    r.guard_id || "",
    r.kind || "",
    (Array.isArray(r.reasons) ? [...r.reasons].sort().join("|") : ""),
    r.start_time || "",
    r.end_time || "",
    (r.notes || "").trim(),
  ].join("§");
}

// ISO-only next-day arithmetic — pure UTC math, no DST surprises.
export function nextDay(iso) {
  const [y, m, d] = iso.split("-").map(Number);
  const dt = new Date(Date.UTC(y, m - 1, d));
  dt.setUTCDate(dt.getUTCDate() + 1);
  return dt.toISOString().slice(0, 10);
}
